import React from 'react'
import Home from '../pages/Home';
import Contact from '../pages/Contact';
import Gallery from '../pages/Gallery';
import { BrowserRouter as Router, Routes, Route, Link, useLocation } from 'react-router-dom';
import {AnimatePresence} from 'framer-motion';

function AnimatedRoutes() {
    const location  = useLocation();
    return (
        <AnimatePresence>
            <Routes location={location} key={location.pathname}>
                <Route exact path='/' element={<Home/>}> </Route>
                <Route path='/gallery' element={<Gallery/>}> </Route>
                <Route path='/contact' element={<Contact/>}> </Route>
            </Routes>
        </AnimatePresence>
    )
}

export default AnimatedRoutes